module.exports = __webpack_public_path__ + "static/media/background-alternative-alternative-energy-blades.d33e9967.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/background-alternative-alternative-energy-blades.jpg
// module id = 1741
// module chunks = 0